import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
    '327bd0e267aab41862c5120727f05f93T1JERVI6MzkyNzQsRVhQSVJZPTE2NzgzNjk1NzQwMDAsS0VZVkVSU0lPTj0x',
);